//import { stringHasValue } from "@/utils/helpers";
//import { axiosService } from "@/services/AxiosService.js";

class UserService {
  USER_COOKIE = "ZDZW_cookie";
  USER_KEYCLOAK = "keycloak";

  constructor() {}

  stringHasValue(val) {
    return (
      val !== undefined &&
      val !== null &&
      typeof val === "string" &&
      val.trim().length > 0
    );
  }

  getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }

  decodeJWT(token) {
    const base64Url = token.split(".")[1]; // La parte del payload
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  getCookieUser() {
    let user = undefined;

    let cookie = this.getCookie(this.USER_COOKIE);

    if (this.stringHasValue(cookie)) {
      try {
        user = this.decodeJWT(cookie);
      } catch (e) {
        console.error("Error decoding JWT: ", e);
      }
    }
    //return localStorageService.getKeycloak();
    return user;
  }

  getKeycloak() {
    var keycloakData = localStorage.getItem(this.USER_KEYCLOAK);
    return this.stringHasValue(keycloakData)
      ? JSON.parse(keycloakData)
      : undefined;
  }

  getKeycloakUser() {
    return this.getKeycloak();
  }

  // getUser(baseApi) {
  //   console.log("getUser: ", baseApi);
  //   var kUser = this.getKeycloak();

  //   var user = {
  //     username: kUser["tokenParsed"]["preferred_username"],
  //     email: kUser["tokenParsed"]["email"],
  //     firstName: kUser["tokenParsed"]["given_name"],
  //     lastName: kUser["tokenParsed"]["family_name"]
  //   };
  //   return axiosService.doPost(`${baseApi}/authentication/get/user`, user);
  // }
}

export const userService = new UserService();
